import { render } from "./Wallets.vue?vue&type=template&id=59f778f4&scoped=true"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"

import "./Wallets.vue?vue&type=style&index=0&id=59f778f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f778f4"]])

export default __exports__